import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { ServersService } from './servers.service';
import { HttpCacheService } from './httpcache.service';

@Injectable()
export class TipoServicioService {
    constructor(private http: HttpCacheService, private servers: ServersService) { }

    getAll(callback: any) {
        return this.http.get(0, this.servers.serverName + '/tiposervicio', callback);
    }

    save(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/tiposervicio', object, callback);
    }
    update(object: any, callback: any) {
        return this.http.put(30, this.servers.serverName + '/tiposervicio/' + object.id, object, callback);
    }

    updateState(object: any, callback: any) {
        var url = this.servers.serverName + '/tiposervicio/update/state/' + object.id;
        return this.http.put(0, url, object, callback);
    }
}



// WEBPACK FOOTER //
// ./src/app/servicios/tiposervicio.service.ts